import React from 'react'
import { Section } from '../atoms'
import {
  Heading,
  Display,
  Center,
  Columns,
  Box,
  Centered,
  Content,
} from '../../design-system'

export const ErrorMessage = () => (
  <Section>
    <Centered>
      <Columns spacing={3}>
        <Box>
          <Content>
            <Center>
              <Heading>Sorry</Heading>
              <Display>!!!</Display>
              <p>
                Something went wrong.
                <br />
                We’re onto it.
              </p>
            </Center>
          </Content>
        </Box>
      </Columns>
    </Centered>
  </Section>
)
